<template>
    <div class="container">
        <div class="col-md-12">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="col-md-9 d-flex justify-content-end">
            <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="createTasa">
                <md-icon>add</md-icon>
            </md-button>
        </div>
        <div class="row justify-content-center mt-3" v-if="listadoTasas.length > 0">
            <div class="col-md-6">
                <b-table
                    :items="listadoTasas"
                    :fields="fields"
                    hover
                    bordered
                    responsive
                    sticky-header="500px"
                    small
                    class="tblEstandar"
                    head-variant="custom-blue"
                    :per-page="perPage"
                    :current-page="currentPage"
                    @row-clicked="(item) => editTasa(item.id)"
                >
                    <template #cell(tipo_tasa)="data">
                        <div class="text-left">{{ nameTipoTasa(data.item.tipo_tasa) }}</div>
                    </template>
                    <template #cell(valor)="data">
                        <div class="text-right">{{ data.item.valor }}</div>
                    </template>
                </b-table>
                <div class="row col-md-12 mt-1">
                    <div class="col-md-10 d-flex justify-content-center">
                        <b-pagination
                            v-model="currentPage"
                            :per-page="perPage"
                            :total-rows="listadoTasas.length"
                            align="center"
                            size="md"
                            class="custom-pagination"
                        ></b-pagination>
                    </div>
                    <div class="col-md-2 d-flex justify-content-end">
                        <label class="mr-2 mb-0">Filas por página:</label>
                        <b-form-select
                            v-model="perPage"
                            :options="[5, 10, 20, 50, 100, 500]"
                            size="sm"
                            style="width: 80px;"
                        ></b-form-select>
                    </div>
                </div>
                <!-- <md-table md-card md-fixed-header v-model="listadoTasas">
                    <md-table-row slot="md-table-row" slot-scope="{ item }" @click="editTasa(item.id)">
                        <md-table-cell :md-label="labels.tipoTasa" class="border">{{ nameTipoTasa(item.tipo_tasa) }}</md-table-cell>
                        <md-table-cell :md-label="labels.valor" class="border text-left">{{ item.valor }}</md-table-cell>
                        <md-table-cell :md-label="labels.vigencia" class="border text-left">{{ item.vigencia }}</md-table-cell>
                    </md-table-row>
                </md-table> -->
            </div>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5>
        </div>
        <Crear :modCrearTasa="showCrearTasa" @cierraModal="closeModal"/>
        <Editar :modEditarTasa="showEditarTasa" :infoTasa="dataTasa" @cierraModal="closeModal"></Editar>
    </div>
</template>

<script>
import Tasas from '../../../services/Tasas';
import TipoTasa from '../../../services/TipoTasas';
import Crear from './Crear.vue';
import Editar from './Editar.vue';

export default {
    name: 'Tasas',
    components:{Crear,Editar},
    data:() => ({
        listadoTasas : [],
        showCrearTasa : false,
        listTipoTasa : [],
        showEditarTasa : false,
        dataTasa : [],
        perPage: 10,
        currentPage: 1,
        fields: [
            { key: 'tipo_tasa', label: 'Tipo tasa', sortable: false },
            { key: 'valor', label: 'Valor', sortable: false },
            { key: 'vigencia', label: 'Vigencia', sortable: false },
        ],
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Registro y mantenimiento de Tasas',
                    noRow : "No hay registros",
                    tipoTasa : '---Tipo Tasa---',
                    valor : '---Valor---',
                    vigencia : '---Vigencia---',
                }
            }else{
                return {
                    title : 'Rates',
                    noRow : "There are not records",
                    tipoTasa : 'Rate type',
                    valor : 'Worth',
                    vigencia : 'Validity',
                }
            }
        }
    },
    methods:{
        createTasa(){
            this.showCrearTasa = true
        },
        editTasa(id){
            Tasas.getTasaById(id)
            .then((res) => {
                this.dataTasa = res.data.tasa
                this.showEditarTasa = true
            })
            .catch((err) => console.log(err))
        },
        closeModal(val){
            this.showCrearTasa = val
            this.showEditarTasa = val
        },
        nameTipoTasa(numTipoTasa){
            // console.log(numTipoTasa);
            let tipoTasa = this.listTipoTasa.find((tipTasa) => tipTasa.tipo_tasa === numTipoTasa)
            return tipoTasa.descripcion
        }
    },
    mounted(){
        Tasas.getAllTasas()
        .then((res) => {
            // console.log(res.data.listTasas);
            this.listadoTasas = res.data.listTasas
        })
        .catch((err) => { console.log(err) })

        TipoTasa.getAllTipoTasas()
        .then((res) => {
            // console.log(res.data.listTipoTasas);
            this.listTipoTasa = res.data.listTipoTasas
        })
        .catch((err) => { console.log(err) })
    }
}
</script>

<style lang="css">
  .md-table-cell-container {
    padding: 15px !important;
  }
  .md-table-head-label {
    padding-left: 34px !important;
  }
</style>
